import React from 'react';

import { CheckCircle as CheckCircleIcon, Error as ErrorIcon } from '@mui/icons-material';
import { Box, Paper, Typography } from '@mui/material';

import { Field } from '@hrlogics/react-components/form';

import { StripeAccountStatus } from 'src/api';
import { Tooltip } from 'src/components/common';
import { SwitchField } from 'src/components/finalForm';
import { useCurrentUserPermissions } from 'src/hooks/user';
import { SxProp } from 'src/types/mui';

interface BillingMethodCardProps {
  fieldName: string;
  stripeAccountStatus: string | undefined;
}

export const BillingMethodCard: React.FC<BillingMethodCardProps> = ({
  fieldName,
  stripeAccountStatus,
}) => {
  const { isPlatformAdmin } = useCurrentUserPermissions();

  const isCompleted = stripeAccountStatus === StripeAccountStatus.Completed;

  const revenueShareStatusIcon = isCompleted ? (
    <CheckCircleIcon style={{ color: '#388E3C' }} />
  ) : (
    <ErrorIcon style={{ color: '#FF3D00' }} />
  );

  const billingMethodStatusText = isCompleted
    ? 'Billing method is configured'
    : 'Billing method is not configured';

  return (
    <Paper sx={paperStyles} elevation={0}>
      <Box mr="auto">
        <Box display="flex" alignItems="center">
          <Typography variant="subtitle1" mr={3}>
            {billingMethodStatusText}
          </Typography>
          <Tooltip title={billingMethodStatusText}>{revenueShareStatusIcon}</Tooltip>
        </Box>
        <Typography variant="body1" color="text.secondary">
          Toggle off to deactivate Revenue Share
        </Typography>
      </Box>
      <Field
        sx={{ marginRight: 0 }}
        component={SwitchField}
        disabled={!isPlatformAdmin}
        name={fieldName}
      />
    </Paper>
  );
};

const paperStyles: SxProp = theme => ({
  display: 'flex',
  padding: '20px 24px',
  border: theme.constantStyles?.paperBorder,
  borderRadius: theme.constantStyles?.paperBorderRadius,
});
